import { SignatureSearchCriteria } from "entities/UIModel";
import { useSignatureDefaults } from "utils/context/SignatureDefaultsContext";
import { useSignatures } from "utils/context/SignaturesContext";

const useSignature = () => {
  const [, { getSignatures }] = useSignatures();
  const [, { getDefaults }] = useSignatureDefaults();

  const refreshAllSignaturesStateContext = (agencyID?: string) => {
    const criteria: SignatureSearchCriteria = {
      includeImageData: 0,
      listCount: -1, // all signatures 
      requestedPage: 1,
    }
    const updateStateContext = true;
    getSignatures(agencyID, criteria, updateStateContext); // intentionally not to use "await" hre, because it will set the state context once it's completed
  }

    const refreshAllDefaultSignaturesStateContext = (agencyID?: string) => {
    const criteria: SignatureSearchCriteria = {
      includeImageData: 0,
      listCount: -1, // all defaults 
      requestedPage: 1,
    }
    const updateStateContext = true;
    getDefaults(agencyID, criteria, updateStateContext); // intentionally not to use "await" hre, because it will set the state context once it's completed
  }

  return {
    refreshAllSignaturesStateContext,
    refreshAllDefaultSignaturesStateContext,
  }

}

export default useSignature;